import React from 'react';
import propTypes from 'prop-types';
import CarrierLucideIcon from 'components/CarrierLucideIcon/CarrierLucideIcon';
import CarrierInitialsAvatar from './CarrierInitialsAvatar';
import { cn } from 'lib/utils';

/**
 * round carrier avatar for the oep sidebar: the carrier's lucide icon when the
 * record has one, its initials otherwise
 * @param carrier - normalized carrier (needs name, carrierIcon, carrierIconColor)
 * @param className - extra classes for the icon wrapper (e.g. a selected ring)
 */
export default function CarrierAvatar({ carrier, className }) {
  if (!carrier.carrierIcon) {
    return (
      <span className={cn('flex shrink-0 rounded-full', className)}>
        <CarrierInitialsAvatar name={carrier.name} size={32} />
      </span>
    );
  }

  return (
    <span
      className={cn(
        'flex size-8 shrink-0 items-center justify-center rounded-full bg-primary-lighter',
        className
      )}
    >
      <CarrierLucideIcon
        name={carrier.carrierIcon}
        color={carrier.carrierIconColor}
        size={18}
      />
    </span>
  );
}

CarrierAvatar.propTypes = {
  carrier: propTypes.object.isRequired,
  className: propTypes.string
};
